/**
 * Sorgu hata verdiğinde tablonun yerine geçen kısa ve dürüst satır (`stok-analiz/KartHatasi` ile aynı
 * dil): boş liste gibi çizilmez, yeniden deneme düğmesi vardır.
 */
export function RaporHatasi({
  mesaj = 'Veri yüklenemedi.',
  onTekrar,
  testid = 'rapor-hatasi',
}: {
  mesaj?: string;
  onTekrar?: () => void;
  testid?: string;
}) {
  return (
    <div
      data-testid={testid}
      className="flex-1 min-h-0 flex flex-col items-center justify-center gap-3 bg-surface border border-border rounded-lg p-8"
    >
      <p role="alert" className="m-0 text-[13px] text-ink-500 text-center">{mesaj}</p>
      {onTekrar && (
        <button
          type="button"
          onClick={onTekrar}
          className="focus-ring h-8 px-3 rounded-md border border-border-strong bg-surface text-[13px] font-medium text-ink-700 hover:bg-ink-50"
        >
          Tekrar dene
        </button>
      )}
    </div>
  );
}
